import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

interface FormAutocompleteFieldProps<T> {
  fetchOptions: (search: string) => Promise<T[]>;
  getOptionLabel: (option: T) => string;
  onChange: (selected: T | null) => void;
  id: string;
}

const FormAutocompleteField = <T,>({
  fetchOptions,
  getOptionLabel,
  onChange,
  id,
}: FormAutocompleteFieldProps<T>) => {
  const [search, setSearch] = useState("");

  const { data: options = [], isLoading } = useQuery({
    queryKey: ["autocompleteOptions", search, id],
    queryFn: () => fetchOptions(search),
    enabled: !!search,
    staleTime: 300000, // Cache results for 5 minutes
  });

  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      onChange={(event, value) => onChange(value)}
      onInputChange={(event, value) => setSearch(value)}
      loading={isLoading}
      sx={{ width: 300 }}
      getOptionKey={(option) => (option as any).id.toString()}
      renderInput={(params) => (
        <TextField
          {...params}
          label="חיפוש לפי שם"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
            sx: {
              borderRadius: "0.8rem",
              ...(params.InputProps as any).sx,
            },
          }}
        />
      )}
    />
  );
};

export default FormAutocompleteField;
